import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { getUserInformation } from '../components/Login/loginService';
import { Button } from 'material-ui';
import { connect } from 'react-redux';
import { Subject } from 'rxjs';
import { getCMSConfiguration } from './cmsLib';

import isEqual from 'lodash.isequal'

const selectedTabSubject = new Subject();

export const dataService = {
    setData: d => selectedTabSubject.next({ tab: d }),
    clearData: () => selectedTabSubject.next(),
    getData: () => selectedTabSubject.asObservable()
};

class SearchTabs extends React.Component {
    constructor(props, context) {
        super(props);
        this.state = {
            currentHash: 'loading',
            selectedTab: {}
        };
        this.currentUser = getUserInformation();

       
    }
    componentDidMount() {
        window.addEventListener('hashchange', this.checkHash, false);
        this.checkHash();
    }

    componentDidUpdate(prevProps) {

        if ( !isEqual(prevProps.selectedTab, this.props.selectedTab) ) {
            this.handleSelectedTab(this.props.selectedTab);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('hashchange', this.checkHash, false);
    }

    checkHash = () => {
        //esto es mas flojito que gago pero bueno.
        let hash = window.location.hash;
        hash = hash.replace(/\?.+/, '');
        let page = hash.split('/').pop();
        page = unescape(page);
        //http://localhost:3006/#/buscar/form1
        this.setState({ currentHash: page });
    }

    // Fire an event to notify the selected tab
    handleSelectedTab = (t) => {
        dataService.setData(t); 
        localStorage.setItem('selectedTab', JSON.stringify(t));
    };
    
    render() { 
            const siteTabs = getCMSConfiguration()['tabs'];
            return <div className="SearchTabs">
            {siteTabs.map((t) => {   
                let linkname = t.orden;
                let cname = Number(this.state.currentHash) === linkname ? 'cmsTabSelected cmsTab' : 'cmsTab';
                return <Button key={t.orden}  href={'#/search/' + t.orden} onClick={() => this.handleSelectedTab(t)}  className={cname} >{t.label.value}</Button>;
            }
            )}
        </div>;
    }
}

SearchTabs.propTypes = {
    tabs: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
    selectedTab: state.tabsRedux.selectedTab
});


export default connect(mapStateToProps)(translate('translations')(SearchTabs));


// WEBPACK FOOTER //
// ./src/cms/SearchTabs.js